import { Box, Typography } from "@mui/material";
import React from "react";

const STATUS_STYLES = {
  pending: {
    bg: "#FFF8E5",
    color: "#CC9200",
  },
  created: {
    bg: "#FFF8E5",
    color: "#CC9200",
  },
  approved: {
    bg: "#d1fae5",
    color: "#047857",
  },
  declined: {
    bg: "#FFE5E8",
    color: "#FF3347",
  },
  deactivated: {
    bg: "#F2F2F2",
    color: "#4D4D4D",
  },
};

const StatusChip = ({ status , outlined}) => {
  const key = status?.toLowerCase();

  const style = STATUS_STYLES[key] || STATUS_STYLES.deactivated;

  

  return (
    <Box
      sx={{
        px: 1,
       py:0.5,
        borderRadius: "50px",
        backgroundColor: style.bg,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
     
        outline: outlined ? `1px solid ${style.color}b7` : "none",
      }}
    >
      <Typography
        sx={{
          color: style.color,
          fontWeight: 600,
          fontSize: "10px",
          textTransform: "uppercase",
        }}
      >
        {status?.toLowerCase()}
      </Typography>
    </Box>
  );
};

export default StatusChip;